import { refreshToken, logout, pendingRefreshToken } from './auth/actions';
import { AUTH } from '../store/auth/reducer';

let buffer = [];
let pendingActions = [];

export const authMidWare = store => next => action => {
  const state = store.getState();
  const { auth } = state;

  // ((action.type && !action.type.includes('@@redux-form')) || typeof action === 'function') &&
  //   buffer.push(action); // not add redux-form actions

  // if (action.type === AUTH.INVALID_TOKEN) {
  //   if (auth.isAuthenticated) {
  //     const activeFunctions = buffer.filter(el => typeof el === 'function');

  //     if (!auth.pendingRefreshToken) {
  //       pendingActions = pendingActions.concat(activeFunctions);
  //       store.dispatch(pendingRefreshToken(true));

  //       store.dispatch(refreshToken(auth.refreshToken)).then(() => {
  //         pendingActions.forEach(action => {
  //           action(store.dispatch, store.getState);
  //         });
  //         pendingActions = [];
  //         buffer = [];
  //         store.dispatch(pendingRefreshToken(false));
  //       });
  //     }
  //   }
  // } else if (action.type === AUTH.REFRESH_EXPIRED) {
  //   buffer = [];
  //   next(action);
  //   store.dispatch(logout(auth));
  // } else {
  //   if (buffer.length > 5) {
  //     buffer.splice(0, buffer.length - 5);
  //   }
  //   return next(action);
  // }
  if (action && action.type === AUTH.REFRESH_EXPIRED) {
    store.dispatch(logout(auth));
  }

  return next(action);
};
